import { type AccountDetail } from '../api/getSubAccountsByUserApi'

export const getRelationship = (account: AccountDetail, currentUser: any) => {
    if (currentUser && account.userId === currentUser.id) {
        return 'Myself'
    }

    if (!account.relationships || account.relationships.length === 0) {
        return '-'
    }

    const firstChar = account.relationships[0].relationship
        .charAt(0)
        .toUpperCase()

    const restOfWord = account.relationships[0].relationship.slice(1)
    return firstChar + restOfWord
}

export const getInitials = (account: AccountDetail) => {
    const names = account.fullName.split(' ')
    if (names.length === 1) return names[0][0] || ''
    return (names[0][0] || '') + (names[names.length - 1][0] || '')
}
